import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { BiSad } from "react-icons/bi";
import Navbar from "./Navbar";
import { useLocation } from "react-router-dom";

const LeaveAlertsCards = () => {
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchLeaveAlerts = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/leave-alerts",
        JSON.stringify({ patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      setLeaveData(response.data);
    } catch (err) {
      console.error("Failed to fetch leave data", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveAlerts();
  }, []);

  const getStatusBadge = (status, label) => {
    const approved = status ? "Approved" : "Pending";
    const icon = status ? (
      <FaCheckCircle className="text-green-600" />
    ) : (
      <FaTimesCircle className="text-yellow-500" />
    );
    const color = status ? "text-green-700" : "text-yellow-600";

    return (
      <div className="flex items-center gap-2 text-sm">
        {icon}
        <span className={`font-medium ${color}`}>
          {label}: {approved}
        </span>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="text-center py-24 text-lg text-gray-600 animate-pulse">
        Loading leave details...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-teal-100">
      <div className="fixed top-0 left-0 right-0 z-50 shadow bg-white">
        <Navbar />
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-24 pb-12">
        <h2 className="text-3xl font-bold text-center text-emerald-800 mb-10">
          📝 Warden Dashboard – Leave Records
        </h2>

        {leaveData.length === 0 ? (
          <div className="flex flex-col items-center justify-center text-gray-500 pt-24">
            <BiSad className="text-6xl mb-4 text-gray-400" />
            <p className="text-lg font-medium">No leave data found</p>
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {leaveData.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl border border-gray-200 p-6 shadow-md hover:shadow-lg transition-all"
              >
                <div className="mb-4">
                  <h3 className="text-xl font-semibold text-gray-800 mb-1">
                    {item.patient_name || "Unnamed"}{" "}
                    <span className="text-sm text-gray-500">
                      ({item.roll_number || "N/A"})
                    </span>
                  </h3>
                  <p className="text-sm text-gray-600">
                    Leave Type:{" "}
                    <span className="font-medium text-emerald-600">
                      {item.leave_type || "—"}
                    </span>
                  </p>
                  <p className="text-sm text-gray-600">
                    Duration:{" "}
                    <span className="font-medium">
                      {item.from_date} → {item.to_date}
                    </span>
                  </p>
                  <p className="text-sm text-gray-600">
                    Reason:{" "}
                    <span className="italic text-gray-700">
                      {item.reason || "—"}
                    </span>
                  </p>
                </div>

                <div className="border-t pt-3 space-y-2">
                  {getStatusBadge(item.leave_approval_status_by_doctor, "Doctor")}
                  {getStatusBadge(item.leave_approval_status_by_parent, "Parent")}
                  {getStatusBadge(item.leave_approval_status_by_warden, "Warden")}
                  {getStatusBadge(item.leave_approval_status_by_medical_officer, "Medical Officer")}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaveAlertsCards;
